import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	FieldLayout,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useState } from "react";
import { payrollEarningsRl1Codes, payrollEarningsT4Codes } from "../../AdminEarningsSetup/Panels/AdminEarningsInfoSetupFieldsPanel";

import { Box, useMediaQuery, useTheme } from "@mui/material";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { RHookFormNumericFormatTextField } from "../../TaxSlipDataInput/RHookFormNumericFormatTextField";

interface IEarningsInfoSetupFieldsPanel {
	onEarningsSelectionChangeHandler: (value: any) => void;
	earningsDDLItems: any

}
export const EarningsInfoSetupFieldsPanel: FC<
	IEarningsInfoSetupFieldsPanel
> = ({ earningsDDLItems, onEarningsSelectionChangeHandler }) => {
	const [paymentType, setPaymentType] = useState(100);
	const [hourlyRate, setHourlyRate] = useState(100);
	const onPaymentTypeChangeHandler = (e: any) => {
		setPaymentType(e.value);
	};
	const onHourlyRateChangeHandler = (e: any) => {
		setHourlyRate(e.value);
	};

	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;

	return (
		<Box
			sx={{
				padding: "0",
				"& .MuiTextField-root": { marginTop: 0, marginBottom: "12px" },
			}}
		>
			{mobileTabOrSmallLaptopScreen && <EnhancedDropDownRHFWithLabel
				label="Load Earnings"
				selectName="earnings"
				testId={`earnings`}
				labelPosition={LabelPosition.Top}
				items={earningsDDLItems ?? []}
				onSelectionChangeHandler={onEarningsSelectionChangeHandler}
				showEmpty
			/>}
			<RHookFormTextFieldWithLabel
				label="Label"
				id="label"
				testId={`label`}
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
			// required
			/>
			<EnhancedDropDownRHFWithLabel
				label="Show in Payroll"
				selectName="showInPayroll"
				testId={`Show-in-Payroll`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Earning Type"
				selectName="earningType"
				testId={`Earning-Type`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Cash", value: 100 },
					{ label: "Non Cash", value: 200 }
				]}
				selectedItem={100}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Payment Type"
				selectName="paymentType"
				testId={`Payment-Type`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Amount", value: 100 },
					{ label: "Hours", value: 200 },
					{ label: "Percentage of Gross Only", value: 300 },
				]}
				selectedItem={100}
				// required
				labelColumns={4}
				fieldColumns={8}
				onSelectionChangeHandler={onPaymentTypeChangeHandler}
			/>
			{paymentType === 200 && (
				<EnhancedDropDownRHFWithLabel
					label="Hourly Rate"
					selectName="hourlyRate"
					testId={`Hourly-Rate`}
					labelPosition={LabelPosition.Top}
					items={[
						{ label: "Regular Rate", value: 100 },
						{ label: "1.5 * Regular Rate", value: 200 },
						{ label: "2 * Regular Rate ", value: 300 },
						{ label: "Custom Rate ", value: 400 },
					]}
					selectedItem={100}
					// required
					labelColumns={4}
					fieldColumns={8}
					onSelectionChangeHandler={onHourlyRateChangeHandler}
				/>
			)}
			{hourlyRate === 400 && (
				<FieldWrapper>
					<FieldLayout
						label="Rate"
						testId="Rate"
						labelPosition={LabelPosition.Top}
						labelColumns={4}
						fieldColumns={8}
					>
						<RHookFormNumericFormatTextField
							id={"rate"}
							testId={`rate`}
							defaultValue={"0.00"}
							textAlign={"end"}
						/>
					</FieldLayout>
				</FieldWrapper>
			)}
			<EnhancedDropDownRHFWithLabel
				label="Deduct CPP / QPP"
				selectName="deductCppQpp"
				testId={`Deduct-CPP-QPP`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Deduct EI"
				selectName="deductEi"
				testId={`Deduct-EI`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Deduct Federal Tax"
				selectName="deductFederalTax"
				testId={`Deduct-Federal-Tax`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Deduct Provincial Tax"
				selectName="deductProvincialTax"
				testId={`Deduct-Provincial-Tax`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Deduct QPIP"
				selectName="deductQpip"
				testId={`Deduct QPIP`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Calculate EHT Ontario"
				selectName="calculateEhtOntario"
				testId={`Calculate-EHT-Ontario`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Calculate WSIB/WCB"
				selectName="calculateWsibWcb"
				testId={`Calculate WSIB/WCB`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Deduct CSST"
				selectName="deductCsst"
				testId={`Deduct-CSST`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Deduct HSF"
				selectName="deductHsf"
				testId={`Deduct-HSF`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Calculate Vacation Pay"
				selectName="calculateVocationPay"
				testId={`Calculate-Vacation-Pay`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Calculate Holiday Pay"
				selectName="calculateHolidayPay"
				testId={`Calculate-Holiday-Pay`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Exclude from T4 Box 14"
				selectName="excludeFromT4Box14"
				testId={`Exclude-from-T4-Box-14`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={100}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Exclude from RL-1 Box A"
				selectName="excludeFromRl1BoxA"
				testId={`Exclude from RL-1 Box A`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={100}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="GST/ HST Included"
				selectName="gstHstInclude"
				testId={`GST/ HST Included`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Yes", value: 200 },
					{ label: "No", value: 100 },
				]}
				selectedItem={200}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<FieldWrapper>
				<FieldLayout
					label="Max YTD"
					testId="Max-YTD"
					labelPosition={LabelPosition.Top}
					labelColumns={4}
					fieldColumns={8}
				>
					<RHookFormNumericFormatTextField
						id={"maxYtd"}
						testId={`maxYtd`}
						defaultValue={"0.00"}
						textAlign={"end"}
					/>
				</FieldLayout>
			</FieldWrapper>
			<EnhancedDropDownRHFWithLabel
				label="T4 Code"
				selectName="t4Code"
				testId={`T4-Code`}
				labelPosition={LabelPosition.Top}
				items={payrollEarningsT4Codes}
				// selectedItem={100}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				label="RL-1 Code"
				selectName="rl1Code"
				testId={`rl1Code`}
				labelPosition={LabelPosition.Top}
				items={payrollEarningsRl1Codes}
				// selectedItem={100}
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
		</Box>
	);
};
